
export { DossierModule } from './dossier.module';
export { DossierResolver } from './dossier.resolver';
export { DossierListComponent } from './dossier-list.component';
export { DossierEditComponent } from './dossier-edit.component';